// We reuse the "No data" message from Earnings for "Fortnite Games" page
export const NO_DATA_ERROR_CODE = 'epic.affiliate.earnings.no_data';
